/** Formatação de decimais recebidos da API como string. */
export function formatQty(
  value: string | number | null | undefined,
  precision = 2,
  locale = 'pt-BR',
): string {
  if (value === null || value === undefined || value === '') return '—';
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value);
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: precision,
  }).format(n);
}

export function formatMoney(
  value: string | number | null | undefined,
  currency = 'BRL',
  locale = 'pt-BR',
): string {
  if (value === null || value === undefined || value === '') return '—';
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value);
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    maximumFractionDigits: 4,
  }).format(n);
}

export function formatPercent(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') return '—';
  const n = Number(value);
  return Number.isFinite(n)
    ? `${new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 }).format(n)}%`
    : String(value);
}

/** Normaliza entrada do usuário ("1.234,5" ou "1234.5") para string decimal com ponto. */
export function parseDecimalInput(raw: string): string {
  const t = raw.trim();
  if (!t) return '';
  if (/^-?\d+(\.\d+)?$/.test(t)) return t;
  const normalized = t.replace(/\./g, '').replace(',', '.');
  return /^-?\d+(\.\d+)?$/.test(normalized) ? normalized : t;
}

export function isDecimalString(value: string): boolean {
  return /^-?\d{1,12}(\.\d{1,6})?$/.test(value);
}
